var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{attrs:{"id":"app"}},[(!_vm.isBrowserSupported)?_c('div',{staticClass:"unsupported-block"},[(!_vm.isBrowserSupported)?_c('b-field',[_c('b-message',{attrs:{"type":"is-danger"}},[_vm._v("\n                "+_vm._s(_vm.texts.browserNotSupported)+"\n            ")])],1):_vm._e()],1):_c('router-view')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46190218","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 